import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import logo from "../../../assets/logo.svg";
import "../../css/Header.css";
import { FaChevronDown, FaBars, FaTimes } from "react-icons/fa";


const Header = () => {
  const [dropdown, setDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(null);
  const location = useLocation();

  // SCROLL EFFECT
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Why TestOps", path: "/why-testops" },
    {
      label: "Solutions",
      items: [
        { label: "By Team", path: "/byteam" },
        { label: "By Work Flow", path: "/workflow" },
      ],
    },
    {
      label: "Resources",
      items: [
        { label: "Integration", path: "/Integration" },
        { label: "Mobile App", path: "/mobile-app" },
      ],
    },
    { label: "Self Service", path: "/login" },
    { label: "Froth AI", path: "/froth-ai" },
    { label: "Change Log", path: "/change-log" },
    {
      label: "Login",
      path: "https://login.frothtestops.com/",
      external: true,
    },
  ];

  const isActiveLink = (path) => {
    if (!path || typeof path !== "string") return false;
    if (path.startsWith("http")) return false;
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  const handleMobileDropdown = (label) => {
    setMobileDropdownOpen(mobileDropdownOpen === label ? null : label);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setMobileDropdownOpen(null);
  };

  return (
    <>
      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div
          className="mobile-menu-overlay active"
          onClick={closeMobileMenu}
        />
      )}

      {/* Mobile Menu Panel */}
      {mobileMenuOpen && (
        <div className="mobile-menu-panel active">
          <div className="mobile-menu-header">
            <span className="mobile-menu-title">Menu</span>
            <button
              className="mobile-menu-close"
              onClick={closeMobileMenu}
            >
              <FaTimes />
            </button>
          </div>
          <nav className="mobile-nav">
            <a
  href="/"
  className={`mobile-nav-link ${
    location.pathname === "/" ? "mobile-nav-link-active" : ""
  }`}
  onClick={closeMobileMenu}
>
  Home
</a>
            {navLinks.map((link, i) => {
              if (link.items) {
                const isDropdownOpen = mobileDropdownOpen === link.label;
                return (
                  <div key={i} className="mobile-nav-item">
                    <button
                      className={`mobile-dropdown-toggle ${
                        isDropdownOpen ? "active" : ""
                      } ${isActiveLink(link.path) ? "mobile-dropdown-toggle-active" : ""}`}
                      onClick={() => handleMobileDropdown(link.label)}
                    >
                      <span>{link.label}</span>
                      <FaChevronDown className={`mobile-dropdown-arrow ${isDropdownOpen ? "active" : ""}`} />
                    </button>
                    <div className={`mobile-dropdown-menu ${isDropdownOpen ? "active" : ""}`}>
                      {link.items.map((item, j) => (
                        <a
                          key={j}
                          href={item.path}
                          className={`mobile-dropdown-link ${
                            isActiveLink(item.path) ? "mobile-dropdown-link-active" : ""
                          }`}
                          onClick={closeMobileMenu}
                        >
                          {item.label}
                        </a>
                      ))}
                    </div>
                  </div>
                );
              }

              return link.external ? (
                <a
                  key={i}
                  href={link.path}
                  target="_blank"
                  rel="noreferrer"
                  className="mobile-nav-link"
                  onClick={closeMobileMenu}
                >
                  {link.label}
                </a>
              ) : (
                <a
                  key={i}
                  href={link.path}
                  className={`mobile-nav-link ${
                    isActiveLink(link.path) ? "mobile-nav-link-active" : ""
                  }`}
                  onClick={closeMobileMenu}
                >
                  {link.label}
                </a>
              );
            })}
            
            <a
              href="/contact"
              className="mobile-nav-link mobile-contact-btn"
              onClick={closeMobileMenu}
            >
              Contact Us
            </a>
          </nav>
        </div>
      )}

      <header className={`header-main ${location.pathname === "/" ? "header-home" : "header-other"} ${isScrolled ? "header-scrolled" : ""}`}>
        <div className="header-container">

          {/* LEFT LOGO */}
          <a href="/" className="header-logo">
            <img src={logo} alt="logo" />
          </a>

          {/* Mobile Menu Button */}
          <button
            className={`header-mobile-btn ${mobileMenuOpen ? "active" : ""}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          
          {/* CENTER NAV */}
          <nav className="header-nav">
            {navLinks.map((link, i) => {
            if (link.items) {
              return (
                <div
                  key={i}
                  className="header-nav-item header-dropdown"
                  onMouseEnter={() => setDropdown(link.label)}
                  onMouseLeave={() => setDropdown(null)}
                >
                  <span className="header-nav-link">
                    {link.label} <span className="header-arrow"><FaChevronDown /></span>
                  </span>

                  {dropdown === link.label && (
                    <div className="header-dropdown-menu">
                      {link.items.map((item, j) => (
                        <a
                          key={j}
                          href={item.path}
                          className={`header-dropdown-link ${isActiveLink(item.path) ? "header-dropdown-link-active" : ""}`}
                        >
                          {item.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            return link.external ? (
              <a
                key={i}
                href={link.path}
                target="_blank"
                rel="noreferrer"
                className="header-nav-link"
              >
                {link.label}
              </a>
            ) : (
              <a
                key={i}
                href={link.path}
                className={`header-nav-link ${isActiveLink(link.path) ? "header-nav-link-active" : ""}`}
              >
                {link.label}
              </a>
            );
          })}
        </nav>

        {/* RIGHT BUTTON */}
        <div className="header-right">
          <a href="/contact" className="header-contact-btn">
            Contact Us
          </a>
        </div>
      </div>
    </header>
    </>
  );
};

export default Header;